module.exports = __webpack_public_path__ + "img/josh-hidayat.0dfbfe4d.jpg";